var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-2 md:pl-0 break-normal text-gray-900 text-base md:text-lg"},[(_vm.isLoading)?_c('SimplePlaceholder'):_c('span',{staticClass:"text-gray-900 font-bold text-xl"},[_vm._v("\n    "+_vm._s(_vm.$tc('products_title', _vm.pagination.total_count))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }